import {
  APIErrorResponse,
  ManualHoursReport,
  PaginatedListResponse,
  SearchRequestParams,
} from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from '@/hooks/api/useQueryList'
import { QUERY_KEYS } from '@/constants'

export type ManualHoursReportsSearchParams = SearchRequestParams & {
  user?: string
  contractors?: string
  startDate?: string
  endDate?: string
  status?: string
}

export const getUseManualHoursReportsKey = (hr = true): string[] =>
  (hr
    ? QUERY_KEYS.MANUAL_HOURS_HR_REPORTS
    : QUERY_KEYS.MANUAL_HOURS_REPORTS
  ).slice(0, 3) as string[]

export const useManualHoursReports = (
  { ...params }: ManualHoursReportsSearchParams,
  enabled = true,
  hr = true
): UseQueryResult<PaginatedListResponse<ManualHoursReport>, APIErrorResponse> =>
  useQueryList({
    url: hr
      ? '/hours_reporting/hr/manual-hours/'
      : '/hours_reporting/manual-hours/',
    options: {
      enabled,
    },
    params: {
      ...(hr &&
        !!params.user && {
          user: params.user,
        }),
      ...(hr &&
        !!params.contractors && {
          contractors: params.contractors,
        }),
      ...(!!params.startDate && { date_start: params.startDate }),
      ...(!!params.endDate && { date_end: params.endDate }),
      ...(!!params.status && { status: params.status }),
      limit: params.limit,
      offset: params.offset,
    },
    key: hr
      ? [...QUERY_KEYS.MANUAL_HOURS_HR_REPORTS, params]
      : [...QUERY_KEYS.MANUAL_HOURS_REPORTS, params],
  })
